import client from "libs/HttpClient";
import { AxiosRequestConfig } from "axios";

/**
 * Represents the structure of a request for listing users.
 */
interface ListUserRequest {
  queryKey: [number, string, string];
}

/**
 * Service class for handling products types.
 */
class LicenceUserService {
  /**
   * Updates the details of a Licence User based on the provided request.
   *
   * @param request - The request parameters for updating a Licence User.
   * @returns A Promise that resolves to the Axios response for the update Licence User request.
   */
  static UpdateLicenceUserVerify(request: any) {
    return client.post("admin/licence/user/confirmMail", request);
  }

  static listUserLicence(request: ListUserRequest) {
    const page_no = request.queryKey[0];
    const searchText = request.queryKey[1];
    const status = request.queryKey[2];

    return client.get(
      `admin/licence/user/list?page=${page_no}&search_text=${searchText}&status=${status}`,
      request as AxiosRequestConfig
    );
  }
  /**
   * Updates the status of a user based on the provided request.
   *
   * @param request - The request parameters for updating the status of a user.
   * @returns A Promise that resolves to the Axios response for the update status request.
   */
  static updateStatusUser(request: any) {
    return client.patch("admin/licence/user/update-status/", request);
  }

  static deleteUser(params: any) {
    return client.delete("admin/licence/user/delete-user", { params });
  }
}

export { LicenceUserService };
